import { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '@redux-actions/';
import { getInsuranceBenefits, getInsuranceCode, getLabels } from '@utils/utils';
import useWindowSize from '@hooks/useWindowSize';
import {isMobile} from '@utils/utils';
import CartLoader from '@components/CartLoader';

import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import TypPage from './pages/TypPage';

import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { Helmet } from 'react-helmet';

import BossApp from '@components/Boss/BossApp';
import Loader from '@components/Loader';

declare global {
    interface Window {
        globalMethods: any;
        BindIDme: any;
        paypal_disabled: boolean;
        products: any;
        tealium_data2track: any;
        affirm: any;
        utag_data: any;
        utag: any;
        forterWebId: any;
        klarnaAsyncCallback: any;
        KlarnaOnsiteService: any;
        monetateQ: any;
    }
}

export default ({data}) => {
    const dispatch = useDispatch();
    
    const [configLoaded, setConfigLoaded] = useState(false);
    const [isKeyboardUser, setIsKeyboardUser]= useState(false);

    const openModal = useSelector(state => state.cart.openModal);
    const config = useSelector(state => state.cart.config);
    const isLoading = useSelector(state => state.cart.isLoading);
    
    /*
        globalMethods -  object that contains all the function called from the functions defined in
        'callFromComponentToGl' object in config object.
    */
    const globalMethods = {
        backFromLogin: () => {
            if(window.location.pathname !== data.pagesUrl.typ) {
                dispatch(actions.populateCart(data.mockRequests, data.hostname));
            }
        },
        backFromCreateAccount: () => {
            if(window.location.pathname !== data.pagesUrl.typ) {
                dispatch(actions.populateCart(data.mockRequests, data.hostname));
            }
        },
        onInsuranceClosing: (value) => {
            if(config.cartLensUpsell.enabled === true){
                dispatch(actions.endLoading());
            }
            dispatch(actions.setInsurance(undefined));
            dispatch(actions.setInsurance(value));
            if(value === true) {
                window?.tealium_data2track?.push({
                    'tealium_event': 'Insurance',
                    'Order_InsuranceBenefits': getInsuranceBenefits(),
                    'Order_InsuranceCode': getInsuranceCode()
                })
            }
        },
        onRecalculateInsuranceEnd: (value) => {
            if(config.cartLensUpsell.enabled === true){
                dispatch(actions.endLoading());
            }           
            dispatch(actions.setInsurance(undefined));
            dispatch(actions.setInsurance(value));

            if(value === true) {
                window?.tealium_data2track?.push({
                    'tealium_event': 'Insurance',
                    'Order_InsuranceBenefits': '',
                    'Order_InsuranceCode': ''
                })
            } else {
                window?.tealium_data2track?.push({
                    'tealium_event': 'Insurance-Tentative',
                    'Order_InsuranceCode': 'Unknown',
                    'Events_Error': '1',
                    'Error_Source': 'User',
                    'Error_Code': 'InsurancePanel',
                    'Error_Message': 'Insurance error',
                    'Events_InsuranceTentative': '1'
                })
            }
        }
    }

    window.globalMethods = globalMethods;

    // for accessibility
	const setKeyboardUser = e => {
		if (e.code === 'Tab') {
			setIsKeyboardUser(true);
		}
	}

	const unsetKeyboardUser = () => {
       setIsKeyboardUser(false);
	}

    /* At first render, save the config, get labels, and calls getCart */
    useEffect(() => {
        dispatch(actions.saveConfig(data));
        getLabels(data.langUrl);
        if(window.location.pathname !== data.pagesUrl.typ) {
            dispatch(actions.populateCart(data.mockRequests, data.hostname, data));
        }

        //attach events for 'Tab' navigation
        window.addEventListener('keydown', setKeyboardUser);
		window.addEventListener('mousedown', unsetKeyboardUser);
    }, []);

    const size = useWindowSize();

    //every time the size of the window changes, control if it is a mobile or desktop view
    useEffect(() => {
        const isMobileValue = isMobile.any() || size.width < 1200
        dispatch(actions.setIsMobile(isMobileValue));
    }, [size])

    //when the config is loaded, set the corresponding state variable
    useEffect(() => {
        if(!!config && configLoaded === false)  {
            setConfigLoaded(true);
        }
    }, [config]);
    
    return (
        <div 
            id="glasses-headless-storelocator" 
            className={'glasses-storelocator-content'}>
            {!config &&
                <Loader 
                    classes={"align-center-loader-default-image" + (config ? " hide" : " show")}
               />
            }
            {/* Asynchronously add in the Head of the HTML page the affirm script */}
            {configLoaded &&
                <BossApp config={config} shipModeId="001"></BossApp>
            }
        </div>
    );
};